<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content [innerHtml]="data.message | safeHtml"> </mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    id="BTN_message_dialog_ok"
    mat-raised-button
    [mat-dialog-close]="true"
    class="btn btn-primary"
  >
    {{ "global.ok" | translate }}
  </button>
</mat-dialog-actions>
